import * as styled from "./LoadingIconStyles";

const LoadingIcon = ({
  styleProps,
  text,
  centerHorizontally = false,
  centerVertically = false,
  whiteBackground = false,
}: {
  styleProps?: object;
  text?: string;
  centerHorizontally?: boolean;
  centerVertically?: boolean;
  whiteBackground?: boolean;
}) => {
  return (
    <styled.Container
      style={styleProps}
      centerHorizontally={centerHorizontally}
      centerVertically={centerVertically}
      whiteBackground={whiteBackground}
    >
      <styled.Icon whiteBackground={whiteBackground} />
      <div>{text}</div>
    </styled.Container>
  );
};

export default LoadingIcon;
